import React from "react";
import { Trash2, Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

export default function DeleteBrokerageDialog({ target, busy, onConfirm, onClose }) {
  return (
    <AlertDialog open={!!target} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent data-testid="brokerage-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display flex items-center gap-2 text-red-700">
            <Trash2 className="h-5 w-5" /> Delete brokerage
          </AlertDialogTitle>
          <AlertDialogDescription className="text-slate-600">
            <strong>{target?.name}</strong> will be moved to the Recycle Bin.
            {" "}Its <strong>{target?.realtor_count ?? 0} realtor
            {target?.realtor_count === 1 ? "" : "s"}</strong> will be
            unassigned — their profiles stay intact and searchable.
            Restore from the Recycle Bin re-attaches them automatically.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} className="min-h-[44px]">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={busy}
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            className="bg-red-600 hover:bg-red-700 text-white min-h-[44px]"
            data-testid="brokerage-delete-confirm"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Trash2 className="h-4 w-4 mr-2" />}
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
